import _extends from "@babel/runtime/helpers/extends";
import { AcornsIcon } from '@acorns/icons';
import React from 'react';
import { BadgeIcon, BodyContainer, CloseButton, CloseIcon, LearnTipTitle, StyledBadge, TopContainer, LearnTipBodyContent } from './styled-components';
export var LearnTipContent = function LearnTipContent(_ref) {
  var step = _ref.step,
      skipProps = _ref.skipProps,
      handleClose = _ref.handleClose;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TopContainer, {
    backgroundImageUrl: step.backgroundImageUrl
  }, step.badgeIcon && /*#__PURE__*/React.createElement(BadgeIcon, {
    icon: step.badgeIcon
  }), step.badgeText && !step.badgeIcon && /*#__PURE__*/React.createElement(StyledBadge, null, step.badgeText), /*#__PURE__*/React.createElement(CloseButton, _extends({}, skipProps, {
    onClick: handleClose || skipProps.onClick,
    "data-testid": "".concat(step.dataTestId, "_close_button")
  }), /*#__PURE__*/React.createElement(CloseIcon, {
    icon: AcornsIcon.Icon.CloseXIcon,
    height: 12,
    width: 12
  }))), /*#__PURE__*/React.createElement(BodyContainer, {
    hasBottomPadding: !step.showButtons
  }, step.title && /*#__PURE__*/React.createElement(LearnTipTitle, null, step.title), step.content && /*#__PURE__*/React.createElement(LearnTipBodyContent, null, step.content)));
};